
    // Do not modify this file by hand!
    // Re-generate this file by running lit-localize

    
    

    /* eslint-disable no-irregular-whitespace */
    /* eslint-disable @typescript-eslint/no-explicit-any */

    export const templates = {
      's1488e73779d7682f': `1) Otvorte ponuku prehliadača`,
's182ab2d6c997515f': `Pridajte ju na domovskú obrazovku pre rozšírené využitie a jednoduchý prístup.`,
's1b9047d53d9f9d22': `2) Stlačte Zdieľať na navigačnom paneli`,
's2d90afa5dcca2c0e': `3) Prejdite nadol k "Pridať na domovskú obrazovku"`,
's37a9e8aec5713460': `Viac`,
's4593f304dac8848c': `2) Klepnite na "Pridať na domovskú obrazovku"`,
's54cfbb14f46396d4': `1) Otvorte v hlavnom prehliadači`,
's6196153c4b0c1ea0': `Inštalovať`,
's922329d6f6213590': `Pridať do Docku`,
'sa5ef80b4bb9b39f8': `Menej`,
'sa7551383d1897fcc': `2) Stlačte Pridať do Docku`,
'sba52286c21552a4e': `Nainštalujte si ju na svoje zariadenie pre rozšírené využitie a jednoduchý prístup.`,
'sc79fd7641eb9a975': `Skryť inštrukcie`,
'scdaf4bbff76674c8': `Pridať na domovskú obrazovku`,
'se740f75b95a51807': `Pridajte ju do Docku pre rozšírené využitie a jednoduchý prístup.`,
'sfea652f6580ff086': `Táto stránka má funkcie aplikácie.`,
    };
  